export default __webpack_public_path__ + "static/loyall-featured-image-marketing-light-e66020343fcb7fcbc1ac2131b4dad28e.jpg";